/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Loading from "../components/Loading";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import _ from "lodash";

import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab";

import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Paper as MuiPaper,
  TextField,
  Typography,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
  Alert,
  Snackbar,
} from "@mui/material";
import { Box, spacing } from "@mui/system";
import { connect } from "react-redux";
import axios from "../../CustomAxios";
import moment from "moment";
import { CSVLink } from "react-csv";
import { Download } from "@mui/icons-material";

const Card = styled(MuiCard)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);

function FormDetails({ user, details, paymentLogs, challanCSV, headCSV, onSyncComplete }) {
  const userData = JSON.parse(localStorage.getItem('AuthData'));
  const navigate = useNavigate();
  const [irnMessage, setIrnMessage] = useState("");
  const [irnLoader, setIrnLoader] = useState(false);
  const [irnError, setIrnError] = useState(false);
  const [irn, setIrn] = useState(details[0]?.irn_no ? details[0].irn_no : "");
  const [extID, setExtId] = useState(details[0]?.external_bill_id ? details[0]?.external_bill_id : "");
  const [state, setState] = React.useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal, open } = state;
  const snackRef = useRef(null);
  const [cashPayment, setCashPayment] = useState(details[0]?.cash_payment ? details[0].cash_payment : false);

  // New state for bulk sync
  const [syncLoading, setSyncLoading] = useState(false);
  const [syncSnackbar, setSyncSnackbar] = useState({ open: false, message: '', severity: 'info' });

  const headCells = [
    { key: "id", alignment: "left", label: "S.No" },
    { key: "amount_paid", alignment: "left", label: "Amount Paid" },
    { key: "time", alignment: "left", label: "Timestamp" },
    { key: "action_by", alignment: "left", label: "Action By" },
    { key: "role", alignment: "left", label: "Role" },
    { key: "remarks", alignment: "center", label: "Remarks" },
  ];

  let csvRows = [];
  const csvReport = {
    filename: `${details[0].bill_id}-Payment-Logs.csv`,
    headers: headCells,
    data: csvRows,
  };

  const challanCSVReport = {
    filename: `${details[0].bill_id}-Challan-Table.csv`,
    headers: headCSV,
    data: challanCSV,
  };

  const handleClick = (newState) => () => {
    setState({ ...newState, open: true });
  };

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const generateIRN = async () => {
    setIrnLoader(true);
    if (userData?.type === "super_admin") {
      const config = {
        headers: {
          Authorization: 'Bearer ' + userData.access_token,
        },
      };
      const { data } = await axios.get(`/api/v1/${userData.type}/bill/${details[0]._id}/generate_irn`, config);
      if (data.success) {
        setIrnError(false);
        setIrn(data.data.irn_no);
        setExtId(data.data.external_bill_id);
        snackRef.current.click();
        setIrnMessage(data.data.message);
      } else {
        snackRef.current.click();
        setIrnError(true);
        setIrnMessage(data.message);
      }
    }
    setIrnLoader(false);
  };

  // Bulk sync handler
  const handleBulkSync = async () => {
    setSyncLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem('AuthData'));
      const config = {
        headers: {
          Authorization: 'Bearer ' + authData.access_token,
        },
      };
      // Adjust API endpoint as per your backend route
      const { data } = await axios.put(`/api/v1/${authData.type}/bill/${details[0]._id}/sync_jobs`, {}, config);
      if (data.success) {
        setSyncSnackbar({ open: true, message: data.message || 'Bill synced successfully!', severity: 'success' });
        // Option 1: Reload the page to fetch fresh data
        window.location.reload();
        // Option 2: Call onSyncComplete if provided to refresh parent component
        if (onSyncComplete) onSyncComplete();
      } else {
        throw new Error(data.message || 'Sync failed');
      }
    } catch (err) {
      setSyncSnackbar({ open: true, message: err.response?.data?.message || err.message, severity: 'error' });
    } finally {
      setSyncLoading(false);
    }
  };

  const handleSyncSnackbarClose = () => {
    setSyncSnackbar({ ...syncSnackbar, open: false });
  };

  return (
    <>
      <Button
        ref={snackRef}
        style={{ display: 'none' }}
        onClick={handleClick({ vertical: 'top', horizontal: 'center' })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        {irnError ? (
          <Alert mt={2} mb={4} severity='error'>
            {irnMessage}
          </Alert>
        ) : !irnError && irn.length !== 0 ? (
          <Alert mt={2} mb={4} severity='success'>
            {irnMessage}
          </Alert>
        ) : null}
      </Snackbar>

      {/* Snackbar for sync feedback */}
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={syncSnackbar.open}
        autoHideDuration={6000}
        onClose={handleSyncSnackbarClose}
      >
        <Alert onClose={handleSyncSnackbarClose} severity={syncSnackbar.severity}>
          {syncSnackbar.message}
        </Alert>
      </Snackbar>

      <Card mb={6}>
        <CardContent>
          <Paper elevation={3} style={{ padding: "2%" }}>
            <Grid container spacing={5}>
              <Grid item xs={12} md={6} lg={6}>
                <Typography color="primary" variant="h6" gutterBottom>
                  Bill Details
                </Typography>
              </Grid>
              <Grid item xs={12} lg={6} md={6} style={{ textAlign: "right" }}>
                {/* Sync Bill Button - only for users with appropriate permissions */}
                {((userData?.type === "ap_user" && user.role?.permissions?.includes("sync_jobs")) || userData?.type === "super_admin") && (
                  <>
                    {syncLoading ? (
                      <CircularProgress size={20} color="primary" style={{ marginRight: '10px' }} />
                    ) : (
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleBulkSync}
                        style={{ marginRight: '10px' }}
                        disabled={irn !=="" ? true : false}
                      >
                        Sync Bill
                      </Button>
                    )}
                  </>
                )}
                {/* Generate IRN Button */}
                {((userData?.type === "ap_user" && user.role?.permissions?.includes("generate_irn")) || userData?.type === "super_admin") && irn?.length === 0 && details[0]?.ap_company?.is_irn_allowed && !cashPayment && (
                  <>
                    {irnLoader ? (
                      <CircularProgress size={20} color="primary" />
                    ) : (
                      <Button
                        type='submit'
                        style={{ textAlign: 'center', margin: '10px' }}
                        mr={2}
                        variant='contained'
                        color='primary'
                        onClick={generateIRN}
                      >
                        Generate IRN
                      </Button>
                    )}
                  </>
                )}
              </Grid>

              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  type="text"
                  fullWidth
                  label="Bill ID"
                  value={details[0]?.bill_id}
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  type="text"
                  fullWidth
                  label="Bill Name"
                  value={details[0]?.name}
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  fullWidth
                  name="ap_company"
                  value={`${details[0]?.ap_company?.name} [${details[0]?.ap_company?.company_code}]`}
                  label="AP Company"
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  fullWidth
                  name="customer_company"
                  value={details[0]?.customer_company?.name}
                  label="Customer Company"
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  type="text"
                  fullWidth
                  label="Delivery Address"
                  value={
                    details[0]?.delivery?.address_line_one +
                    " " +
                    details[0]?.delivery?.address_line_two +
                    " " +
                    details[0]?.delivery?.city +
                    " " +
                    details[0]?.delivery?.state +
                    " - PinCode: " +
                    details[0]?.delivery?.pincode
                  }
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  type="text"
                  fullWidth
                  label="Billing Date"
                  value={moment(new Date(details[0]?.billing_date)).format(
                    "DD-MM-YYYY | hh:mm A"
                  )}
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  type="text"
                  fullWidth
                  label="Description"
                  value={details[0]?.description}
                  inputProps={{ readOnly: true }}
                  multiline
                />
              </Grid>
              {irn.length !== 0 ? (
                <>
                  <Grid item xs={12} md={6} lg={6}>
                    <TextField
                      type="text"
                      fullWidth
                      label="IRN Number"
                      value={irn}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <TextField
                      type="text"
                      fullWidth
                      label="External Bill ID"
                      value={extID}
                      inputProps={{ readOnly: true }}
                    />
                  </Grid>
                </>
              ) : ""}
            </Grid>
          </Paper>
        </CardContent>
      </Card>

      {/* Challan Details Table (unchanged) */}
      <Card mb={6}>
        <CardContent>
          <Paper elevation={3} style={{ padding: "2%" }}>
            <Grid container spacing={5}>
              <Grid item xs={12} md={6} lg={6}>
                <Typography color="primary" variant="h6" gutterBottom>
                  Chalan Details
                </Typography>
              </Grid>
              <Grid
                xs={12}
                md={6}
                lg={6}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <CSVLink
                  style={{ color: "green", textDecoration: "none" }}
                  {...challanCSVReport}
                >
                  <Button
                    variant="outlined"
                    sx={{ ml: 2, mr: 2 }}
                    endIcon={<Download />}
                  >
                    CSV
                  </Button>
                </CSVLink>
              </Grid>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell colSpan={5}></TableCell>
                      <TableCell align="center" colSpan={2}>
                        Plate
                      </TableCell>
                      <TableCell align="center" colSpan={2}>
                        Baking
                      </TableCell>
                      <TableCell align="center" colSpan={2}>
                        Printout
                      </TableCell>
                      <TableCell align="center" colSpan={2}>
                        Discount
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Challan Id</TableCell>
                      <TableCell align="left">Job Id</TableCell>
                      <TableCell align="left">Job Name</TableCell>
                      <TableCell align="left">HSN</TableCell>
                      <TableCell align="left">Plate Name</TableCell>
                      <TableCell align="left">Quantity</TableCell>
                      <TableCell align="left">Price</TableCell>
                      <TableCell align="left">Quantity</TableCell>
                      <TableCell align="left">Price</TableCell>
                      <TableCell align="left">Quantity</TableCell>
                      <TableCell align="left">Price</TableCell>
                      <TableCell align="left">Discount %</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {details.map((row) => (
                      <TableRow
                        key={row._id}
                        hover
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate(
                            `/dashboard/challan/challan-details/${row?.challans?._id}`,
                            {
                              state: { challan: row?.challans },
                            }
                          )
                        }
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell align="left">
                          {row?.challans?.challan_id}
                        </TableCell>
                        <TableCell align="left">
                          {row?.challans?.jobs?.job_id}
                        </TableCell>
                        <TableCell align="left">
                          {row?.challans?.jobs?.name}
                        </TableCell>
                        <TableCell align="left">
                          {row?.challans?.jobs?.plates?.plate_details?.hsn}
                        </TableCell>
                        <TableCell align="left">
                          {row?.challans?.jobs?.plates?.plate_details?.height}*
                          {row?.challans?.jobs?.plates?.plate_details?.width}*
                          {
                            row?.challans?.jobs?.plates?.plate_details
                              ?.thickness
                          }
                          _
                          {
                            row?.challans?.jobs?.plates?.plate_details?.brand
                              ?.name
                          }
                          _
                          {
                            row?.challans?.jobs?.plates?.plate_details
                              ?.technology?.name
                          }
                        </TableCell>
                        <TableCell align="center">
                          {row?.challans?.jobs?.plates?.quantity}
                        </TableCell>
                        <TableCell align="center">
                          {row?.challans?.jobs?.plates?.selling_cost}
                        </TableCell>
                        <TableCell align="center">
                          {row?.challans?.jobs?.plates?.bake === undefined
                            ? 0
                            : row?.challans?.jobs?.plates?.bake}
                        </TableCell>
                        <TableCell align="center">
                          {row?.challans?.jobs?.plates?.baking_cost}
                        </TableCell>
                        <TableCell align="center">
                          {row?.challans?.jobs?.plates?.printout === undefined
                            ? 0
                            : row?.challans?.jobs?.plates?.printout}
                        </TableCell>
                        <TableCell align="center">
                          {row?.challans?.jobs?.plates?.print_cost}
                        </TableCell>
                        <TableCell align="center">
                          {row?.discount_percent || 0}%
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Paper>
        </CardContent>
      </Card>

      {/* Payment Logs Accordion (unchanged) */}
      <Card mb={6}>
        <CardContent>
          <Paper elevation={3} style={{ padding: "2%" }}>
            <Grid container spacing={5}>
              <Grid item xs={12} md={12} lg={12}>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography color="primary" variant="h6" gutterBottom>
                      Payment Logs
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid item xs={12} md={12} lg={12}></Grid>
                    <Timeline position="alternate">
                      {paymentLogs.map((payment, ind) => {
                        csvRows.push({
                          id: ind + 1,
                          amount_paid: Number(payment.amount),
                          time: new Date(payment.timestamp),
                          action_by: payment?.action_by?.name || "Super Admin",
                          role:
                            _.upperCase(payment?.user_type) || "SUPER ADMIN",
                          remarks: payment?.remarks ? payment.remarks : "",
                        });

                        return ind % 2 === 0 ? (
                          <TimelineItem key={ind}>
                            <TimelineOppositeContent
                              align="right"
                              variant="body2"
                              color="secondary"
                            >
                              <br />
                              {moment(payment.timestamp).format("MMM DD, YYYY")}
                              <br />
                              {moment(payment.timestamp).format(" hh:mm A")}
                            </TimelineOppositeContent>
                            <TimelineSeparator>
                              <TimelineConnector />
                              <TimelineDot color="primary" variant="outlined" />
                              <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>
                              <Typography variant="h6" component="span">
                                {payment?.action}
                              </Typography>
                              <Typography variant="body1">
                                By- {payment?.action_by?.name || "Super Admin"}
                              </Typography>
                              <Typography variant="body2">
                                {_.upperCase(payment?.user_type) || "SUPER ADMIN"}
                              </Typography>
                              {payment.remarks && (
                                <Typography variant="body2">
                                  Remarks : {payment?.remarks}
                                </Typography>
                              )}
                            </TimelineContent>
                          </TimelineItem>
                        ) : (
                          <TimelineItem key={ind}>
                            <TimelineOppositeContent
                              variant="body2"
                              color="secondary"
                            >
                              <br />
                              {moment(payment.timestamp).format("MMM DD, YYYY")}
                              <br />
                              {moment(payment.timestamp).format(" hh:mm A")}
                            </TimelineOppositeContent>
                            <TimelineSeparator>
                              <TimelineConnector />
                              <TimelineDot color="primary" />
                              <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>
                              <Typography variant="h6" component="span">
                                {payment?.action}
                              </Typography>
                              <Typography variant="body1">
                                By- {payment?.action_by?.name || "Super Admin"}
                              </Typography>
                              <Typography variant="body2">
                                {_.upperCase(payment?.user_type) || "SUPER ADMIN"}
                              </Typography>
                              {payment.remarks && (
                                <Typography variant="body2">
                                  Remarks : {payment?.remarks}
                                </Typography>
                              )}
                            </TimelineContent>
                          </TimelineItem>
                        );
                      })}
                    </Timeline>
                    {paymentLogs && paymentLogs.length > 0 && (
                      <Box
                        sx={{
                          mt: 5,
                          display: "flex",
                          alignContent: "center",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Button variant="outlined">
                          <CSVLink
                            style={{
                              color: "#000",
                              width: "500px",
                              textDecoration: "none",
                            }}
                            {...csvReport}
                          >
                            Export to CSV
                          </CSVLink>
                        </Button>
                      </Box>
                    )}
                  </AccordionDetails>
                </Accordion>
              </Grid>
            </Grid>
          </Paper>
        </CardContent>
      </Card>
    </>
  );
}

const getBillDetails = async (
  id,
  setDetails,
  setPaymentLogs,
  setLoader,
  compId,
  setChallanCSV
) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData?.access_token,
      },
    };
    let url = "";
    if (authData?.type === "customer_user") {
      url = `/api/v1/${authData?.type}/${compId}/bill/${id}`;
    } else {
      url = `/api/v1/${authData?.type}/bill/${id}`;
    }
    const { data } = await axios.get(url, config);

    let csv = [];
    if (data.success) {
      setDetails(data.data);
      data.data.data.map((row) => {
        return csv.push({
          challan_id: row?.challans?.challan_id,
          job_id: row?.challans?.jobs?.job_id,
          job_name: row?.challans?.jobs?.name,
          hsn: row?.challans?.jobs?.plates?.plate_details?.hsn,
          plate_name:
            row?.challans?.jobs?.plates?.plate_details?.height +
            "*" +
            row?.challans?.jobs?.plates?.plate_details?.width +
            "*" +
            row?.challans?.jobs?.plates?.plate_details?.thickness +
            "_" +
            row?.challans?.jobs?.plates?.plate_details?.brand?.name +
            "_" +
            row?.challans?.jobs?.plates?.plate_details?.technology?.name,
          plate_quantity: row?.challans?.jobs?.plates?.quantity,
          plate_cost: row?.challans?.jobs?.plates?.selling_cost,
          bake_quantity: row?.challans?.jobs?.plates?.bake,
          bake_cost: row?.challans?.jobs?.plates?.baking_cost,
          print_quantity: row?.challans?.jobs?.plates?.printout,
          print_cost: row?.challans?.jobs?.plates?.print_cost,
        });
      });
      setChallanCSV(csv);
    }
    let paymentLogsUrl = "";
    if (authData?.type === "customer_user") {
      paymentLogsUrl = `/api/v1/${authData?.type}/${compId}/bill/${id}/payment_logs`;
    } else {
      paymentLogsUrl = `/api/v1/${authData?.type}/bill/${id}/payment_logs`;
    }

    const payment = await axios.get(paymentLogsUrl, config);
    if (payment.data.success) {
      if (payment.data.data.payment_logs) {
        setPaymentLogs(payment.data.data.payment_logs);
      }
    }

    setLoader(false);
  } catch (e) {
    setLoader(false);
  }
};

function BillDetails({ auths }) {
  const { bill_id } = useParams();
  const [user, setUser] = useState([]);
  const [loader, setLoader] = useState(true);
  const [details, setDetails] = useState([]);
  const [paymentLogs, setPaymentLogs] = useState([]);
  const [challanCSV, setChallanCSV] = useState([]);

  const headCSV = [
    { key: "challan_id", alignment: "left", label: "Challan Id" },
    { key: "job_id", alignment: "left", label: "Job Id" },
    { key: "job_name", alignment: "left", label: "Job Name" },
    { key: "hsn", alignment: "left", label: "HSN" },
    { key: "plate_name", alignment: "left", label: "Plate Name" },
    { key: "plate_quantity", alignment: "center", label: "Plate Quantity" },
    { key: "plate_cost", alignment: "center", label: "Plate Cost" },
    { key: "bake_quantity", alignment: "center", label: "Bake Quantity" },
    { key: "bake_cost", alignment: "center", label: "Bake Cost" },
    { key: "print_quantity", alignment: "center", label: "Print Quantity" },
    { key: "print_cost", alignment: "center", label: "Print Cost" },
  ];

  const refreshBillData = () => {
    const compId = auths?.user?.customer_company?._id;
    getBillDetails(bill_id, setDetails, setPaymentLogs, setLoader, compId, setChallanCSV);
  };

  useEffect(() => {
    setUser(auths.user);
    const compId = auths?.user?.customer_company?._id;
    getBillDetails(bill_id, setDetails, setPaymentLogs, setLoader, compId, setChallanCSV);
  }, [bill_id, auths.user]);

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              BILL DETAILS
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/bill">
                All Bills
              </Link>
              <Typography>Bill Details</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <FormDetails
              user={user}
              details={details.data}
              paymentLogs={paymentLogs}
              challanCSV={challanCSV}
              headCSV={headCSV}
              onSyncComplete={refreshBillData}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(BillDetails);